import React, { useState } from 'react';
import SavedFilterHeader from './SavedFilterHeader';
import { ControlIcon } from './CompactControls';

const API = process.env.REACT_APP_API_URL || '/api';

export default function SavedFilterCard({ filter, index, active, subscription, onApply, onChanged, onNotificationsChanged }) {
  const [editing, setEditing] = useState(false);
  const [name, setName] = useState(filter.name);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const mutate = async (method, body) => {
    setBusy(true);
    setError('');
    try {
      const response = await fetch(`${API}/favorite-filters/${index}`, {
        method, headers: { Authorization: `Bearer ${localStorage.getItem('token')}`, 'Content-Type': 'application/json' },
        ...(body ? { body: JSON.stringify(body) } : {}),
      });
      if (!response.ok) throw new Error('Promjena filtera nije uspjela.');
      const data = await response.json();
      await onChanged(method === 'DELETE' ? null : data, filter);
      setEditing(false);
      window.dispatchEvent(new Event('news-notifications-changed'));
    } catch (err) { setError(err.message); }
    finally { setBusy(false); }
  };
  return <div className={`saved-filter-item${active ? ' active' : ''}`}>
    {editing ? <div className="filter-edit-mode">
      <input className="filter-name-input" aria-label="Naziv spašenog filtera" value={name} onChange={event => setName(event.target.value)} autoFocus onKeyDown={event => {
        if (event.key === 'Enter' && name.trim()) mutate('PUT', { name: name.trim() });
        if (event.key === 'Escape') setEditing(false);
      }} />
      <div className="filter-actions"><button type="button" disabled={busy || !name.trim()} onClick={() => mutate('PUT', { name: name.trim() })}>Spremi</button><button type="button" onClick={() => setEditing(false)}>Odustani</button></div>
    </div> : <>
      <SavedFilterHeader filter={filter} subscription={subscription} onChanged={onNotificationsChanged} />
      <div className="filter-actions">
        <button type="button" className="apply-btn" onClick={() => onApply(filter)}><ControlIcon name="check" />Primijeni</button>
        <button type="button" className="edit-btn" disabled={busy} onClick={() => { setName(filter.name); setEditing(true); }}><ControlIcon name="edit" />Uredi</button>
        <button type="button" className="delete-btn" disabled={busy} onClick={() => { if (window.confirm('Jeste li sigurni da želite obrisati ovaj filter?')) mutate('DELETE'); }}><ControlIcon name="trash" />Obriši</button>
      </div>
    </>}
    {error && <p role="alert">{error}</p>}
  </div>;
}
